// eslint-disable no-param-reassign

import { propPanelMixin, mapCompProp } from "../../../../lib/helpers";
import ColsEditor from './comps/ColsEditor';
import CustomInputSelector from "./comps/CustomInputSelector";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { vueDeepAssign } from "../../../../lib/utils/vue";
import { getFitDataLayout } from "../../../../lib/utils";

/**
 * @typedef {import('@tencent/data-schema-core').DataStub} DataStub
 */

const __script_base__ = {
  name: 'WFieldPropPanel',
  components: {
    ColsEditor,
    CustomInputSelector
  },
  mixins: [propPanelMixin],
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  },
  computed: {
    path: mapCompProp('path'),
    stub() {
      var _this$designer$render;
      return (_this$designer$render = this.designer.renderer) === null || _this$designer$render === void 0 ? void 0 : _this$designer$render.getStubAtPath(this.getActualProp('path'));
    },
    readonly: mapCompProp('readonly'),
    labelText: mapCompProp('labelText'),
    hideLabel: mapCompProp('hideLabel'),
    fillLine: mapCompProp('fillLine'),
    useCustomInput: mapCompProp('useCustomInput'),
    uiSettings: mapCompProp('uiSettings'),
    tooltipText: mapCompProp('tooltipText'),
    description: mapCompProp('description'),
    rootSchema: {
      get() {
        return this.uc.root.dataSchema;
      },
      set(val) {
        this.uc.root.$emit('update:dataSchema', val);
      }
    },
    supportArrayCols() {
      /** @type {DataStub} */
      const arrayStub = this.stub;
      return (arrayStub === null || arrayStub === void 0 ? void 0 : arrayStub.type) === 'array' && arrayStub.arrItems.type === 'object';
    },
    arrayUsingCols: {
      get() {
        var _this$uiSettings;
        return this.supportArrayCols && ((_this$uiSettings = this.uiSettings) === null || _this$uiSettings === void 0 || (_this$uiSettings = _this$uiSettings.cols) === null || _this$uiSettings === void 0 ? void 0 : _this$uiSettings.length) > 0;
      },
      set(val) {
        if (!this.supportArrayCols) return;
        if (val) {
          if (!this.fillLine) this.fillLine = true; // 贴心fix
          this.arrayCols = this.stub.arrItems.fields.map(f => ({
            id: f.id
          }));
        } else {
          this.arrayCols = null;
        }
      }
    },
    arrayHideNumber: {
      get() {
        var _this$uiSettings2;
        return !!((_this$uiSettings2 = this.uiSettings) !== null && _this$uiSettings2 !== void 0 && _this$uiSettings2.hideNumber);
      },
      set(val) {
        this.uiSettings = {
          ...this.uiSettings,
          hideNumber: val
        };
      }
    },
    arrayCols: {
      get() {
        var _this$uiSettings3;
        return (_this$uiSettings3 = this.uiSettings) === null || _this$uiSettings3 === void 0 ? void 0 : _this$uiSettings3.cols;
      },
      set(val) {
        const {
          cols: lastCols,
          ...rest
        } = this.uiSettings || {};
        if (!val) this.uiSettings = rest;else this.uiSettings = {
          ...rest,
          cols: val
        };
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    setCustomComponent(answer) {
      if (!answer) return;
      if (answer === 'default') {
        this.modifyComp(c => {
          vueDeepAssign(c, {
            props: {
              useCustomInput: false
            },
            children: []
          });
        });
        return;
      }
      if (answer === 'empty') {
        this.modifyComp(c => {
          vueDeepAssign(c, {
            props: {
              useCustomInput: true
            },
            children: []
          });
        });
        return;
      }
      if (typeof answer === 'object') {
        /** @type {UICore.ComponentFitDataResult} */
        const fitDataResult = answer;
        this.modifyComp(c => {
          vueDeepAssign(c, {
            props: {
              useCustomInput: true
            },
            children: []
          });
          const {
            layout
          } = getFitDataLayout(fitDataResult);
          c.children = [layout];
        });
      }
    },
    askForCustomInput() {
      this.$refs.customInputSelector.askForCustomInput({
        path: this.path
      }).then(this.setCustomComponent);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('p', [_vm._v("\n    当前绑定到："), _c('code', [_vm._v(_vm._s(_vm.path == null ? '（整个数据）' : _vm.path))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.readonly,
      expression: "readonly"
    }],
    staticClass: "uc-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.readonly) ? _vm._i(_vm.readonly, null) > -1 : _vm.readonly
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.readonly,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.readonly = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.readonly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.readonly = $$c;
        }
      }
    }
  }), _vm._v("\n      只读\n    ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.hideLabel,
      expression: "hideLabel"
    }],
    staticClass: "uc-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.hideLabel) ? _vm._i(_vm.hideLabel, null) > -1 : _vm.hideLabel
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.hideLabel,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hideLabel = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.hideLabel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.hideLabel = $$c;
        }
      }
    }
  }), _vm._v("\n      隐藏标签\n    ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.fillLine,
      expression: "fillLine"
    }],
    staticClass: "uc-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.fillLine) ? _vm._i(_vm.fillLine, null) > -1 : _vm.fillLine
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.fillLine,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fillLine = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.fillLine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.fillLine = $$c;
        }
      }
    }
  }), _vm._v("\n      撑满整行\n    ")])]), _vm._v(" "), _c('p', [_c('custom-input-selector', {
    ref: "customInputSelector"
  }), _vm._v(" "), _c('button', {
    staticClass: "uc-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.askForCustomInput
    }
  }, [_vm._v("\n      更换输入框组件\n    ")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.useCustomInput,
      expression: "useCustomInput"
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.setCustomComponent('default');
      }
    }
  }, [_vm._v("重置为默认")])], 1), _vm._v(" "), !_vm.hideLabel ? _c('p', [_c('label', [_vm._v("\n      自定义标签\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.labelText,
      expression: "labelText"
    }],
    staticClass: "uc-inputbox",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "留空则使用默认值"
    },
    domProps: {
      "value": _vm.labelText
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.labelText = $event.target.value;
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', [_c('label', [_vm._v("\n      提示文字\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tooltipText,
      expression: "tooltipText"
    }],
    staticClass: "uc-inputbox",
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": _vm.tooltipText
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.tooltipText = $event.target.value;
      }
    }
  })])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("\n      字段描述\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.description,
      expression: "description"
    }],
    staticClass: "uc-inputbox",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "留空则使用默认值"
    },
    domProps: {
      "value": _vm.description
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.description = $event.target.value;
      }
    }
  })])]), _vm._v(" "), _vm.supportArrayCols ? _c('div', [_c('p', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.arrayHideNumber,
      expression: "arrayHideNumber"
    }],
    staticClass: "uc-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.arrayHideNumber) ? _vm._i(_vm.arrayHideNumber, null) > -1 : _vm.arrayHideNumber
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.arrayHideNumber,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.arrayHideNumber = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.arrayHideNumber = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.arrayHideNumber = $$c;
        }
      }
    }
  }), _vm._v("\n        隐藏序号列\n      ")])]), _vm._v(" "), _c('p', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.arrayUsingCols,
      expression: "arrayUsingCols"
    }],
    staticClass: "uc-checkbox",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.arrayUsingCols) ? _vm._i(_vm.arrayUsingCols, null) > -1 : _vm.arrayUsingCols
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.arrayUsingCols,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.arrayUsingCols = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.arrayUsingCols = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.arrayUsingCols = $$c;
        }
      }
    }
  }), _vm._v("\n        自定义表格列\n      ")])]), _vm._v(" "), _vm.arrayUsingCols ? _c('ColsEditor', {
    attrs: {
      "fields": _vm.stub.arrItems.fields
    },
    model: {
      value: _vm.arrayCols,
      callback: function ($$v) {
        _vm.arrayCols = $$v;
      },
      expression: "arrayCols"
    }
  }) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Field/FieldPropPanel.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);